function copyCurrentURL() {
    const currentURL = window.location.href;
    navigator.clipboard.writeText(currentURL).then(() => {
        showSnackbar();
    });
}
function copymobileCurrentURL() {
    const currentURL = window.location.href;
    navigator.clipboard.writeText(currentURL).then(() => {
        showMobileSnackbar();
    });
}

function showSnackbar() {
  const snackbar = document.getElementById("copy-snackbar");
  snackbar.classList.add("show");
  setTimeout(() => {
    snackbar.classList.remove("show");
  }, 3000);
}
function showMobileSnackbar() {
  const mobileSnackbar = document.getElementById("mobile-copy-snackbar");
  mobileSnackbar.classList.add("show");
  setTimeout(() => {
    mobileSnackbar.classList.remove("show");
  }, 3000);
}
// function hideSnackbar() {
//   document.getElementById("copy-snackbar").classList.remove("show");

// }
// function showSnackbar() {
//   const snackbar = document.getElementById("mobile-copy-snackbar");
//   snackbar.classList.add("show");
//   setTimeout(() => {
//     snackbar.classList.remove("show");
//   }, 3000);
// }
// function hideSnackbar() {
//   document.getElementById("mobile-copy-snackbar").classList.remove("show");
// }

document.addEventListener("DOMContentLoaded", function () {
    const trigger = document.querySelector(".size-chart-trigger");
    const popup = document.querySelector("#SizeChartPopup");
    const closeBtn = popup.querySelector(".size-chart-close");

    if (trigger && popup && closeBtn) {
      trigger.addEventListener("click", () => {
        popup.classList.add("active");
      });

      closeBtn.addEventListener("click", () => {
        popup.classList.remove("active");
      });

      popup.addEventListener("click", (e) => {
        if (e.target === popup) {
          popup.classList.remove("active");
        }
      });
    }
  });
  